import revealOnScroll from "../utils/revealOnScroll"

class WhyChooseUs {
	constructor(selector = ".why-card") {
		this.cards = Array.from(document.querySelectorAll(selector))

		this.init()
	}

	init() {
		if (!this.cards.length) {
			return
		}

		revealOnScroll(this.cards, {
			visibleClass: "visible",
			observerOptions: { threshold: 0.15 }
		})
	}
}

export default WhyChooseUs
